<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 197.209"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="69.248"
            cy="136.204"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M65.064 181.377c-0.021,-1.192 -0.148,-8.449 -0.381,-21.771 5.327,-1.352 10.637,-3.531 15.93,-6.538 0.595,2.895 1.648,6.577 3.263,10.951 1.412,3.824 1.316,9.055 0.001,15.456 -0.291,1.419 -0.791,2.811 -1.495,4.089 -3.138,2.051 -6.399,1.777 -11.207,-0.284 -1.978,-0.848 -4.042,-1.478 -6.111,-1.903z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M45.477 184.99c3.558,-3.822 11.612,-5.248 19.587,-3.613 2.069,0.425 4.133,1.055 6.111,1.903 4.808,2.061 8.069,2.335 11.207,0.284 -2.201,3.993 -6.393,6.873 -12.426,5.992 -2.704,-0.395 -5.043,-1.273 -7.395,-1.928 -1.964,-0.546 -3.938,-0.936 -6.141,-0.76 -3.46,0.278 -6.767,2.64 -11.598,4.668 -0.909,0.381 -1.872,0.751 -2.9,1.092 -3.828,1.273 -7.694,0.904 -11.181,-0.769 7.346,-0.451 9.367,-1.101 14.736,-6.869z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M65.064 181.377c-7.975,-1.635 -16.029,-0.209 -19.587,3.613 -0.217,0.232 -0.428,0.456 -0.634,0.673l0.276 -24.798c6.547,0.81 13.068,0.391 19.564,-1.259 0.233,13.322 0.36,20.579 0.381,21.771z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M45.119 160.865l-0.276 24.798c-4.906,5.147 -7.052,5.763 -14.102,6.196 -4.61,-2.21 -8.561,-6.695 -10.898,-12.671 -3.394,-8.674 -3.255,-18.319 -1.646,-28.494 9.022,5.676 17.996,9.066 26.922,10.171z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M64.683 159.606c-6.496,1.65 -13.017,2.069 -19.564,1.259 -8.926,-1.105 -17.9,-4.495 -26.922,-10.171 0.234,-1.477 0.498,-2.966 0.787,-4.464 7.233,-0.772 13.486,-0.06 18.759,2.138 9.986,3.287 17.378,3.287 22.177,0 8.787,-1.804 15.537,-1.104 20.25,2.1 0.101,0.78 0.247,1.647 0.443,2.6 -5.293,3.007 -10.603,5.186 -15.93,6.538z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M80.17 150.468c-4.713,-3.204 -11.463,-3.904 -20.25,-2.1 -4.799,3.287 -12.191,3.287 -22.177,0 -5.273,-2.198 -11.526,-2.91 -18.759,-2.138m43.577 41.398c-3.784,6.121 -9.697,7.424 -17.739,3.908m39.055 -12.061c1.315,-6.401 1.411,-11.632 -0.001,-15.456 -2.782,-7.533 -3.895,-13.014 -3.876,-15.956 0.093,-14.644 -1.767,-22.569 -2.401,-30.21 -0.673,-8.106 -0.063,-20.16 0.192,-28.864 0.203,-6.906 6.498,-44.303 -0.847,-45.331 -3.241,-0.454 -6.13,5.406 -7.369,7.727 -1.528,2.864 -3.064,6.256 -4.056,8.561 -0.993,2.304 -2.862,6.248 -2.127,4.072 0.736,-2.176 4.079,-10.474 5.071,-14.057 3.474,-12.556 -3.053,-11.708 -10.721,-3.744 -2.496,2.592 -5.311,5.921 -8.448,10.656 -3.136,4.736 -6.593,10.881 -10.337,18.849 -3.744,7.968 -7.777,17.761 -10.624,26.241 -2.848,8.48 -4.513,15.649 -5.729,21.954 -1.215,6.304 -1.206,11.257 -2.255,15.871 -3.227,14.182 -5.092,27.677 -0.506,39.4 4.106,10.497 13.19,16.395 22.079,13.44 6.492,-2.157 10.387,-5.43 14.498,-5.76 4.844,-0.388 8.573,1.963 13.536,2.688 7.962,1.164 12.72,-4.227 13.921,-10.081z"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="82.305"
            cy="41.349"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>

